import React from 'react';
import { padCalendar, numTo2DecimalsPercent, getEntryClass } from "../../../../util";

export const aceAlertsSelectorColumns = ({ onDandOClick, status }) => {

    let columns = [{
			title: "Company Name",
			name: "companyName",
			onClick: (dando) => dando.enabled && onDandOClick(dando),
			getClassName: (dando) => {
				const entryClass = getEntryClass(dando);
				return dando.enabled ? entryClass+'-clickable' : entryClass;
			},
			colNum: 1,
			sortyBy: 'companyName',
			textAlign: 'left',
		},
		{
			title: "Ticker",
			name: "symbol",
			colNum: 2,
			getClassName: getEntryClass,
			sortyBy: "ticker",
		},
		{
			title: "Date Added",
			name: "dateAdded",
			colNum: 3,
			getClassName: getEntryClass,
			format: (dateAdded) => padCalendar(dateAdded),
			sortyBy: "dateAdded",
		},
		{
			title: "Risk Assessment Date",
			name: "riskAssessmentDate",
			colNum: 4,
			getClassName: getEntryClass,
			format: (riskAssessmentDate) => padCalendar(riskAssessmentDate),
			noSort: true, //sortyBy: "riskAssessmentDate",
			width: 150
		},
		{
			title: "SAR Risk Score\u00AE",
			name: "riskDataScore",
			colNum: 5,
			getClassName: getEntryClass,
			format: (riskDataScore) => numTo2DecimalsPercent(riskDataScore),
			sortyBy: "riskScore",
		},
		{
			title: "Last ACE Alert\u00AE",
			name: "lastAlertDate",
			colNum: 6,
			getClassName: getEntryClass,
			format: (lastAlertDate) => padCalendar(lastAlertDate),
			noSort: true //sortyBy: "lastAlertDate",
		}
	]

    return columns;
}


// WEBPACK FOOTER //
// ./src/common/components/TableGrid/tableColumn/AceAlertsSelectorColumns.js